/**
 * Deep-link contract for a US label ``label_version_diff`` citation: open the
 * existing label Version Comparison at the cited pair.
 *
 *   /drug/:drugId?cmpFrom=<from version_number>&cmpTo=<to version_number>
 *
 * The pair is the ``version_diffs`` natural key's version numbers
 * (drug_versions.version_number); DrugDetailPage maps them onto its own
 * compare options and consumes both keys once the compare opens.
 */
import type { SimpleCitation } from '../types/qa';

export const LABEL_COMPARE_FROM = 'cmpFrom';
export const LABEL_COMPARE_TO = 'cmpTo';

/** The compare params for a version-diff citation, else ``null``. */
export function labelVersionDiffParams(c: SimpleCitation): URLSearchParams | null {
  if (c.document_type !== 'label_version_diff'
      || c.from_version_number == null || c.to_version_number == null) {
    return null;
  }
  return new URLSearchParams({
    [LABEL_COMPARE_FROM]: String(c.from_version_number),
    [LABEL_COMPARE_TO]: String(c.to_version_number),
  });
}
